import React from 'react';
import PropTypes from 'prop-types';

const StarIcon = props => (
  <svg width="13" height="13" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7013 3.90838C13.2332 2.83067 14.7699 2.83067 15.3018 3.90838L17.9928 9.3609L24.01 10.2353C25.1993 10.4081 25.6742 11.8696 24.8136 12.7085L20.4595 16.9527L21.4874 22.9456C21.6905 24.1301 20.4473 25.0334 19.3835 24.4742L14.0015 21.6447L8.61958 24.4742C7.55582 25.0334 6.31254 24.1301 6.5157 22.9456L7.54357 16.9527L3.18947 12.7085C2.32887 11.8696 2.80376 10.4081 3.99308 10.2353L10.0103 9.3609L12.7013 3.90838ZM14.0015 4.66308L11.3438 10.0483C11.1326 10.4763 10.7243 10.7729 10.252 10.8415L4.30903 11.7051L8.60941 15.8969C8.95115 16.23 9.1071 16.71 9.02642 17.1804L8.01124 23.0993L13.3268 20.3048C13.7492 20.0827 14.2539 20.0827 14.6763 20.3048L19.9918 23.0993L18.9767 17.1804C18.896 16.71 19.0519 16.23 19.3937 15.8969L23.6941 11.7051L17.7511 10.8415C17.2788 10.7729 16.8705 10.4763 16.6593 10.0483L14.0015 4.66308Z"
      fill="#232323"
    />
  </svg>
);

StarIcon.propTypes = {
  className: PropTypes.string,
};

StarIcon.defaultProps = {
  className: '',
};

export default StarIcon;
